
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
Die Dauer, während der man sich in Innenräumen aufhält, spielt eine wichtige Rolle. Über lange Zeiträume können schon geringe Virenmengen ausreichen, die jemand kontinuierlich ausstösst, um einen ganzen Raum zu infizieren. Social Distancing ist draussen sehr wirksam, in Räumen unter Umständen nicht wirklich. Eine Studie aus Japan berechnet ein rund 19-mal höheres Infektionsrisiko in Innenräumen.
    </p>
    <p>
Die Virologin Muge Cevik von der britischen University of St. Andrews schreibt: «Vermeiden Sie engen, anhaltenden Kontakt in Innenräumen und im öffentlichen Verkehr.» Zudem müssten für einen langfristigen Umgang mit dem neuen Virus bessere Lüftungskonzepte entwickelt werden für Menschen, die auf engem Raum zusammenleben oder <nobr>-arbeiten</nobr>.
    </p>
    <p>
Um die Aerosolkonzentration zu reduzieren, die in Innenräumen vorkommen können, sollte man folgende Situationen meiden:
    </p>
    <p>
  <ul>
    <li>viele Personen an einem Ort</li>
    <li>naher Abstand zu anderen Personen</li>
    <li>schlecht belüftete Räume</li>
    <li>Orte, wo Menschen keine Masken tragen</li>
    <li>Orte, wo laut geredet, gesungen, geschrien oder intensiv geatmet wird</li>
  </ul>
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;